<template>
  <div class="category-filter">
    <div class="filter-header">
      <h3>Categories</h3>
      <button 
        v-if="selectedCategory" 
        @click="clearFilter"
        class="clear-btn"
      >
        Clear
      </button>
    </div>
    
    <div class="categories">
      <button
        v-for="category in categories"
        :key="category.id"
        @click="selectCategory(category.id)"
        :class="['category-btn', { active: selectedCategory === category.id }]"
      >
        {{ category.name }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'CategoryFilter',
  computed: {
    ...mapState({
      categories: state => state.ecommerce.products.categories,
      selectedCategory: state => state.ecommerce.products.selectedCategory
    })
  },
  methods: {
    selectCategory(categoryId) {
      const newCategory = this.selectedCategory === categoryId ? null : categoryId
      this.$store.dispatch('ecommerce/products/updateCategoryFilter', newCategory)
    },
    clearFilter() {
      this.$store.dispatch('ecommerce/products/updateCategoryFilter', null)
    }
  }
}
</script>

<style scoped>
.category-filter {
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.filter-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.filter-header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.clear-btn {
  background: none;
  border: 1px solid #ddd;
  padding: 5px 15px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 14px;
  color: #666;
  transition: all 0.3s ease;
}

.clear-btn:hover {
  background: #f8f9fa;
  border-color: #999;
}

.categories {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.category-btn {
  padding: 8px 16px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 20px;
  cursor: pointer;
  font-size: 14px;
  color: #495057;
  transition: all 0.3s ease;
}

.category-btn:hover {
  background: #e9ecef;
  transform: translateY(-1px);
}

.category-btn.active {
  background: #2ed573;
  color: white;
  border-color: #2ed573;
}
</style>